import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'df-button-new',
  templateUrl: './button-new.component.html',
  styleUrls: ['./button-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonNewComponent {}
